(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('discount-coupons', {
            parent: 'admin',
            url: '/discount-coupon',
            data: {
                pageTitle: 'discount-coupon.title',
                authorities: [],
                // specialClass: "md-skin fixed-nav mini-navbar"
            },
            views: {
                'content@app': {
                    templateUrl: 'app/admin/discount-coupon/discount-coupon-list.html',
                    controller: 'DiscountCouponListController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                type: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('discount-coupon');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
